import React, { FC } from 'react';
import Chart from 'react-apexcharts';
import { useQuery } from '@apollo/client';
import { GET_ADMIN_PRODUCT_DISTRIBUTIONS } from '../../../graphql/admin_queries';
import EmptyPageLoader from '../../../components/EmptyPageLoader';

type GetAdminProductDistributions = {
  data: {
    apartment_search: number;
    pre_rent_guarantee: number;
    rent_guarantee: number;
    rent_payment: number;
    totalUsersCount: number;
  }
}
const ProductAnalysisDistribution: FC = () => {
  const labels = [
    { label: 'Pre-rent Guarantee', key: 'pre_rent_guarantee' },
    { label: 'Rent Guarantee', key: 'rent_guarantee' },
    { label: 'Apartment Search', key: 'apartment_search' },
    { label: 'Rent Payment', key: 'rent_payment' },
  ];
  const chartLabel = labels.map((lb) => lb.label);
  const colors = ['#F07C62', '#609696', '#F0BC68', '#8CB45F'];
  const { data: response, loading } = useQuery<
  {getAdminProductDistributions: GetAdminProductDistributions}>(GET_ADMIN_PRODUCT_DISTRIBUTIONS);
  const stats = response?.getAdminProductDistributions?.data;
  const totalProduct = labels.reduce((prev, curr) => prev + (stats?.[curr.key] || 0), 0);

  const data = {
    options: {
      chart: {
        width: 480,
        height: 480,
      },
      legend: {
        show: false,
      },
      colors,
      labels: chartLabel,
      dataLabels: {
        enabled: false,
        formatter(val) {
          return `$${val}%`;
        },
      },
    },
    series: [
      stats?.pre_rent_guarantee ?? 0,
      stats?.rent_guarantee ?? 0,
      stats?.apartment_search ?? 0,
      stats?.rent_payment ?? 0],
    labels: chartLabel,

  };

  return (

    <div className="product-analysis-distribution">
      <div className="trend_chart__wrapper">
        {loading ? (<EmptyPageLoader />) : (<Chart options={data?.options} series={data?.series} type="donut" width="100%" height={480} />)}
        {!loading && (
          <div className="trend_chart__total">
            <div className="trend_chart__value">{stats?.totalUsersCount ?? 0}</div>
            <div className="trend_chart__title">USERS</div>
          </div>
        )}
      </div>
      <div className="trend_chart__legends">
        <h5>Total products:</h5>
        <p>{totalProduct}</p>
        <div>
          {labels.map((label, index) => (
            <p key={label.key} className="trend_chart__legend">
              <span style={{ backgroundColor: colors[index] }} />
              {label.label}
              <span>{stats?.[label.key] ?? 0}</span>
            </p>
          ))}
        </div>
      </div>
    </div>

  );
};

export default ProductAnalysisDistribution;
